/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Action service
 */
namespace Application.Services {
    'use strict';
    
    import IProfile = Application.Models.IProfile;
    import Profile = Application.Models.Profile;

    /**
     * ProfileService
     */
    export class ProfileService {
        public static $name: string = "profileService";
        public static $inject: string[] = ['$http'];

        private http: ng.IHttpService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'nodestatusaction/streamPipe';
        private backendUrlByBlock: string = this.backendBaseUrl + this.servicePath + 'profiles/block/';

        constructor($http: ng.IHttpService) {
            this.http = $http;
        }
        
        public saveProfile(blockId: number, profile: IProfile): ng.IHttpPromise<boolean> {
            return this.http.post(this.backendUrlByBlock + blockId, profile);
        }

        public saveProfileByStreamPipe(streamHref: string, profile: IProfile): ng.IHttpPromise<boolean> {
            return this.http.post(this.backendUrl + streamHref, profile);
        }

        public loadProfile(blockId: number): ng.IPromise<Profile> {
            return this.http.get(this.backendUrlByBlock + blockId).then((response: ng.IHttpPromiseCallbackArg<Profile>) => {
                return response.data;
            });
        }
    }
}